module.exports = __webpack_public_path__ + "img/8-Look_Woman.bbd1179.png";